import styled from 'styled-components';
import { filterProps } from 'foundations-components/utils/filterProps';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
export const makeSpacedComponent = element => {
  const SpacedContainer = styled(element)(({
    $spaceCssStyles
  }) => {
    return Object.assign({}, $spaceCssStyles);
  });
  return props => {
    const {
      tokenProps,
      domProps
    } = filterProps(props);
    const spaceCssStyles = useMapTokenPropsToCSS(tokenProps);
    return /*#__PURE__*/_jsx(SpacedContainer, Object.assign({
      $spaceCssStyles: spaceCssStyles
    }, domProps, {
      children: props.children
    }));
  };
};
export const SpacedDiv = makeSpacedComponent('div');